import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import Impressum from '../views/impressum.vue'
import Unsubscribe from '../views/unsubscribe.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/impressum',
      name: 'Impressum',
      component: Impressum
    },
    {
      path: '/unsubscribe',
      name: 'Unsubscribe',
      component: Unsubscribe
    }
  ],
  scrollBehavior (to) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
